

import templateBookingPage from '@/app-template/lib/pages/BookingPage.vue';

export default {
  name: "BookingPage",
  components: { templateBookingPage },
};
